import { render, staticRenderFns } from "./BlogListing.vue?vue&type=template&id=017c4065&"
import script from "./BlogListing.vue?vue&type=script&lang=js&"
export * from "./BlogListing.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {OpusButton: require('/~/src/modules/opus/components/Form/Button.vue').default,ContentfulBlogCard: require('/~/src/modules/contentful/components/Blog/BlogCard.vue').default,LayeredPagination: require('/~/src/modules/opus-ecom/components/LayeredPagination.vue').default,OpusIcon: require('/~/src/modules/opus/components/Icon.vue').default})
